import { sendIcon } from './assets/send';

export const templateTextWidget = `
<!doctype html>
<html lang="en">
  <head>
   <link href="https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap" rel="stylesheet">
    <style>
     @import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap');
      *,
      ::after,
      ::before {
        box-sizing: border-box;
      }
      :host {
        font-family: 'Open Sans', sans-serif;
        display: block;
        width: 100%;
        height: 100%;
      }
      #textChatWidget {
        position: fixed;
        bottom: 6em;
        right: 2em;
        z-index: 9999;
        width: 27rem;
        height: 100%;
        max-width: 90vw;
        max-height: 70vh;
        display: flex;
        flex-direction: column;
        border-radius: 1.5rem;
        overflow: hidden;
        transition: width 0.4s ease-in-out, max-width 0.4s ease-in-out, max-height 0.4s ease-in-out;
      }

      #textChatWidget.calendar-expanded {
        width: 34rem;
        max-width: 92vw;
        max-height: 78vh;
      }

      .chat-widget {
        box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
        backdrop-filter: blur(10px);
        transform: translateY(20px);
        opacity: 0;
        animation: slideUp 0.4s ease-out forwards;
      }

      @keyframes slideUp {
        to {
          transform: translateY(0);
          opacity: 1;
        }
      }

      .chat-widget.minimizing {
        opacity: 1;
        transform: translateY(0px);
        animation: slideDown 0.3s ease-in forwards;
      }

      @keyframes slideDown {
        to {
          transform: translateY(20px);
          opacity: 0;
        }
      }

      /* 
      ######################################      
                    Header
      #######################################
      */

      .chat-header {
        background: #120b14;
        padding: 0rem 1rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-shrink: 0;
      }
      .chat-header-left {
        display: flex;
        width: auto;
        justify-content: space-between;
        align-items: center;
     gap: 0.75rem;
      }
      .chat-icon {
        width: auto;
        border-radius: 0.75rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .chat-icon-svg {
        width: 1.25rem;
        height: 1.25rem;
        color: #fff;
      }
      .chat-title {
        color: #fff;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        letter-spacing: -0.14px;
      }
      .chat-title-paragraph{
        color: #999;
        font-size: 8px;
        font-style: normal;
        font-weight: 600;
        margin-top: -10px;
      }
      .chat-status {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50px;
        border: 0.161px solid #fff;
        background: rgba(40, 27, 44, 0.87);
        color: #fff;
        padding-right: 10px;
        padding-top: 4px;
        padding-bottom: 4px;
        padding-left: 10px;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
      .chat-status-dot {
        width: 0.375rem;
        height: 0.375rem;
        background: #4ade80;
        border-radius: 9999px;
        margin-right: 0.375rem;
        animation: pulse 1.5s infinite;
      }
      @keyframes pulse {
        0%,
        100% {
          opacity: 1;
        }
        50% {
          opacity: 0.4;
        }
      }
      .chat-header-right {
        display: flex;
        align-items: center;
        gap: 0.45rem;
      }

      .chat-action-btn {
        border: none;
        background: transparent;
        border-radius: 0.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        width: 2.25rem;
        height: 2.25rem;
        margin-left: 0;
        padding: 0;
        transition: background 0.2s ease, transform 0.2s ease;
      }
      .chat-action-btn:hover {
        background: rgba(255, 255, 255, 0.12);
        transform: translateY(-1px);
      }
      .chat-action-icon {
        width: 1rem;
        height: 1rem;
        color: #fff;
      }

      /* Calendly Button */
      .calendly-btn {
        border: 1px solid rgba(255, 255, 255, 0.22);
        background: transparent !important;
        -webkit-appearance: none;
        appearance: none;
        box-shadow: none;
        border-radius: 0.75rem;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        width: 2.25rem;
        height: 2.25rem;
        padding: 0;
        transition: background 0.2s ease, transform 0.2s ease;
      }
      .calendly-btn:hover {
        background: transparent !important;
        border-color: rgba(255, 255, 255, 0.45);
        transform: translateY(-1px);
      }
      .calendly-btn svg {
        width: 1rem;
        height: 1rem;
        color: #fff;
      }

      .handoff-btn-wrap {
        position: relative;
        display: flex;
        align-items: center;
        flex: 0 0 auto;
      }
      .header-action-wrap {
        position: relative;
        display: flex;
        align-items: center;
        flex: 0 0 auto;
      }
      .handoff-btn {
        border: 1px solid rgba(255, 255, 255, 0.22);
        background: rgba(255, 255, 255, 0.1);
        color: #fff;
        border-radius: 0.75rem;
        cursor: pointer;
        width: 2.25rem;
        height: 2.25rem;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s ease;
        padding: 0;
      }
      .handoff-btn:hover {
        background: rgba(255, 255, 255, 0.18);
        transform: translateY(-1px);
      }
      .handoff-btn:disabled {
        opacity: 0.75;
        cursor: default;
        transform: none;
      }
      .handoff-btn svg {
        width: 1.1rem;
        height: 1.1rem;
        color: #fff;
        display: block;
      }
      .handoff-btn .handoff-icon,
      .handoff-btn .handoff-spinner,
      .handoff-btn .handoff-check {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .handoff-btn .handoff-spinner,
      .handoff-btn .handoff-check {
        display: none;
      }
      .handoff-btn[data-state="waiting"] .handoff-icon,
      .handoff-btn[data-state="requesting"] .handoff-icon,
      .handoff-btn[data-state="assigned"] .handoff-icon {
        display: none;
      }
      .handoff-btn[data-state="waiting"] .handoff-spinner,
      .handoff-btn[data-state="requesting"] .handoff-spinner {
        display: flex;
      }
      .handoff-btn[data-state="assigned"] .handoff-check {
        display: flex;
      }
      .handoff-btn[data-state="requesting"],
      .handoff-btn[data-state="waiting"] {
        background: rgba(255, 255, 255, 0.14);
      }
      .handoff-btn[data-state="assigned"] {
        background: rgba(16, 185, 129, 0.18);
        border-color: rgba(255, 255, 255, 0.34);
      }
      .handoff-btn[data-state="assigned"] .handoff-check svg {
        width: 1rem;
        height: 1rem;
      }
      .handoff-btn[data-state="requesting"] .handoff-spinner svg,
      .handoff-btn[data-state="waiting"] .handoff-spinner svg {
        width: 1rem;
        height: 1rem;
        animation: handoff-spin 0.9s linear infinite;
      }
      @keyframes handoff-spin {
        from {
          transform: rotate(0deg);
        }
        to {
          transform: rotate(360deg);
        }
      }
      .handoff-tooltip {
        position: absolute;
        top: calc(100% + 0.45rem);
        right: 0;
        background: #0f172a;
        color: #fff;
        border-radius: 0.5rem;
        padding: 0.4rem 0.55rem;
        font-size: 11px;
        font-weight: 700;
        line-height: 1;
        white-space: nowrap;
        opacity: 0;
        pointer-events: none;
        transform: translateY(-4px);
        transition: opacity 0.18s ease, transform 0.18s ease;
        box-shadow: 0 10px 25px rgba(15, 23, 42, 0.25);
      }
      .handoff-tooltip::before {
        content: "";
        position: absolute;
        top: -4px;
        right: 0.9rem;
        width: 8px;
        height: 8px;
        background: #0f172a;
        transform: rotate(45deg);
      }
      .handoff-btn-wrap:hover .handoff-tooltip,
      .handoff-btn-wrap:focus-within .handoff-tooltip,
      .header-action-wrap:hover .handoff-tooltip,
      .header-action-wrap:focus-within .handoff-tooltip {
        opacity: 1;
        transform: translateY(0);
      }

      .chat-header-right > .hidden {
        display: none !important;
      }

      /* Calendly Container */
      .calendly-container {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #fff;
        z-index: 10;
        display: none;
      }
      .calendly-container.active {
        display: flex;
        flex-direction: column;
      }
      .calendly-header {
        background: #120b14;
        padding: 1rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-shrink: 0;
      }
      .calendly-title {
        color: #fff;
        font-size: 16px;
        font-weight: 600;
        margin: 0;
      }
      .calendly-close-btn {
        border: none;
        background: transparent;
        color: #fff;
        cursor: pointer;
        font-size: 24px;
        line-height: 1;
        padding: 0;
      }
      .calendly-widget-wrapper {
        flex: 1;
        overflow: hidden;
        position: relative;
      }

      /* Inline Calendly in Chat */
      .calendly-inline-message {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
      }
      .inline-calendly-container {
        background: #ffffff;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        animation: fadeIn 0.3s ease-in-out;
      }
      @keyframes fadeIn {
        from {
          opacity: 0;
          transform: translateY(10px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
      .inline-calendly-header {
        padding: 1rem 1.25rem;
        background: rgb(88 102 135);
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .inline-calendly-header p {
        margin: 0;
        font-size: 15px;
        color: #ffffff;
        font-weight: 600;
        letter-spacing: 0.3px;
      }
      .calendly-skip-btn {
        background: rgba(255, 255, 255, 0.2);
        border: 1px solid rgba(255, 255, 255, 0.3);
        border-radius: 6px;
        padding: 0.5rem;
        cursor: pointer;
        transition: all 0.2s ease;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
      }
      .calendly-skip-btn:hover {
        background: rgba(255, 255, 255, 0.3);
        transform: scale(1.05);
      }
      .calendly-skip-btn:active {
        transform: scale(0.95);
      }
      .calendly-skip-btn svg {
        width: 20px;
        height: 20px;
        stroke: currentColor;
      }
      .inline-calendly-widget {
        width: 100%;
        flex: 1;
        min-height: 0;
        background: #fff;
        overflow: hidden;
      }
      .inline-calendly-widget iframe {
        border: none !important;
      }

      /*
      #############################################
                      floating Button
      #############################################
      */

      #floatingBtn {
        bottom: 15px;
        position: fixed;
        right: 45px;
        z-index: 9999;
        animation: float 3s ease-in-out infinite;
      }
      .floating-btn {
        cursor: pointer;
        align-items: center;
        background: #fc0e3f;
        border: 0;
        border-radius: 9999px;
        box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
        color: #fff;
        display: flex;
        filter: brightness(1.15);
        font-weight: 500;
        overflow: hidden;
        padding: 1.25rem;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      }
      .hidden { display: none !important; }
      .floating-btn:hover {
        filter: brightness(1);
      }
      .floating-btn svg {
        color: #fff;
        width: 2em;
      }
      
      .floating-btn:hover {
        filter: brightness(1);
      }
      .font-medium {
        font-weight: 500;
      }
      .font-semibold {
        font-weight: 600;
      }
      .font-bold {
        font-weight: 700;
      }
      @keyframes float {
        0%,
        100% {
          transform: translateY(0px);
        }
        50% {
          transform: translateY(-5px);
        }
      }

      /* 
      #######################################
      Chat
      ##########################################
      */

      .typing-indicator {
        display: flex;
        margin-top: 6px;
        align-items: center;
        gap: 0.25rem;
      }
      .typing-dots-text  {
        font-size: 1.5rem;
        opacity: 0;
        animation: fadeInOut 1.5s infinite;
      }
      .typing-dots-text:nth-child(1) {
        animation-delay: 0s;
      }
      .typing-dots-text:nth-child(2) {
        animation-delay: 0.5s;
      }
      .typing-dots-text:nth-child(3) {
        animation-delay: 1s;
      }
      @keyframes fadeInOut {
        0%, 100% {
          opacity: 0;
        }
        50% {
          opacity: 1;
        }
      }

      .chat-messages {
        padding: 1.25rem;
        background: #fff;
        height:80%;
        overflow-y: scroll;
      }

      chat-messages {scrollbar-width: thin;
      scrollbar-color: #888 #f5f5f5;  flex: 1; overflow-y: auto; padding: 1rem; display: flex; flex-direction: column; gap: 1rem; }
      .chat-message { display: flex; align-items: flex-start; gap: 0.75rem; }
      .handoff-notification { display: flex; justify-content: center; padding: 2px 0; }
      .handoff-notification-text { background: #f1f5f9; color: #94a3b8; font-size: 11px; padding: 4px 14px; border-radius: 9999px; text-align: center; max-width: 90%; }

      .chat-input {
        padding: 1rem;
        padding-bottom: 0.25rem;
        background: #fff;
        border-top: 1px solid #e2e8f0;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.75rem;
      }
        .chat-input-container{
        display: flex;
        width: 100%;
        gap: 0.5rem;
        margin-top: -15px;
        align-items: center;
        justify-content: space-between;
        }

      .chat-text-input {
        flex: 1;
        background: #ececec;
        border: 1px solid #fff;
        border-radius: 9999px;
        padding: 0.75rem 1rem;
        font-size: 0.875rem;
        
      }
      .chat-send-btn {
        width: 3rem;
        height: 3rem;
        border: none;
        border-radius: 0.75rem;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        cursor: pointer;
      }
      .chat-send-icon {
        width: 1.25rem;
        height: 1.25rem;
      }
      .svg-class-chat {
        margin-top: 3px;
      }
      
       .chat-message-icon { width: 32px; height: 32px; background: #FC0E3F; border-radius: 9999px; display: flex; align-items: center; justify-content: center; }
      .chat-bubble-ai { background: #ececec; border-radius: 1rem 1rem 1rem 1rem; padding: 0.1rem 0.9rem; max-width: 280px; color: #0f172a; font-size: 0.875rem; line-height: 1.3; overflow-wrap: anywhere; word-break: break-word; }
      .chat-bubble-user {
        background: #ffdde4;
        color: #000;
        border-radius: 1rem 1rem 1rem 1rem;
        padding: 0.1rem 0.9rem;
        max-width: 280px;
        font-size: 0.875rem;
        line-height: 1.3;
        overflow-wrap: anywhere;
        word-break: break-word;
            margin-top: 15px;
    margin-bottom: 15px;
      }
      .chat-message-user-icon {
        width: 2rem;
        height: 2rem;
        background: #cbd5e1;
        border-radius: 9999px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
      }
      .chat-message-user-icon svg {
        width: 1rem;
        height: 1rem;
        color: #475569;
      }
      .chat-message.user {
        display:flex;
        flex-direction:row;
        gap:0.5em;
        justify-content: flex-end;
      }
      /* // .chat-padding { padding: 1rem 0.8rem; } */
      .online-ready {
        display: flex;
        flex-direction: row;
        gap: 5px;
        align-items: center;
      }
      .online-ready-text {
        display: flex;
        flex-direction: column;
      }
      /* 
      ######################################

      ########################################
      */

       #chatMessages {
        padding: 1.25rem;
        background: #fff;
        max-height: 50vh;
        height: 30vh;
        overflow-y: scroll;
      }
      .chat-messages .respond {
        background: #fff;
        box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
        padding: 1rem;
        margin-left: 15px;
        border: 1px solid #f3f4f6;
        border-radius: 1rem;
        border-top-left-radius: 0.375rem;
      }
        #logoIcon{
        width: 65px;
        height: 60px;
        border-radius: 8px;
        object-fit: contain;
        margin-left: 10px;

        }

        .powered-by {
  text-align: center;
  font-size: 10px;
  font-weight: 500;
  color: #999;
  margin: 6px 0 10px 0;
  padding: 0;
  opacity: 0.7;
}

.typing-container{
  background: #ececec;
  border-radius: 50px;
  padding: 7px 15px;
  font-size: 14px;
}

.powered-by-brand {
   font-weight: 700;
  color: #666;
    text-decoration: none;
  cursor: pointer;
}
  .powered-by-brand:hover {
  color: #000;
  text-decoration: underline;
}
      .chat-footer{
  background: #fff;
  }

      .feedback-bar {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.75rem;
        padding: 0.75rem 1rem;
        background: #fff;
      }
      .feedback-bar p {
        margin: 0;
        font-size: 12px;
        color: #666;
      }
      .feedback-btn {
        border: 1px solid #e2e8f0;
        background: #fff;
        border-radius: 8px;
        padding: 6px 10px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #555;
        transition: all 0.2s;
      }
      .feedback-btn:hover {
        border-color: #94a3b8;
        background: #f8fafc;
      }
      .feedback-btn.selected {
        border-color: #3b82f6;
        background: #eff6ff;
        color: #3b82f6;
      }
      .feedback-btn svg {
        width: 16px;
        height: 16px;
      }
      .feedback-thanks {
        text-align: center;
        font-size: 12px;
        color: #00b69b;
        padding: 0.5rem;
      }
    </style>
  </head>
  <body>
    <!-- Chat Widget Box -->
    <div id="textChatWidget" class="chat-widget hidden">
      <!-- Header -->
      <div id="chat-header" class="chat-header">
        <div class="chat-header-left">
          <div class="chat-icon">
            <img id="logoIcon" src="./assets/logo.svg" alt="Chat Icon" />
          </div>
          <div class="online-ready">
            <div className="online-ready-text">
              <h3 id="banner-text" class="chat-title">Text Chat</h3>
             
            </div>
          </div>
        </div>
        <div class="chat-header-right">
          <div class="handoff-btn-wrap hidden" id="handoffButtonWrap">
            <button id="handoffButton" class="handoff-btn" type="button" aria-label="Talk to human">
              <span class="handoff-icon" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M4.75 12a7.25 7.25 0 1 1 14.5 0v3.25a1.75 1.75 0 0 1-1.75 1.75h-1.25a1 1 0 0 1-1-1v-3.5a1 1.0 0 0 1 1-1h3" />
                  <path stroke-linecap="round" stroke-linejoin="round" d="M4.75 15.25A1.75 1.75 0 0 0 6.5 17h1.25a1 1 0 0 0 1-1v-3.5a1 1 0 0 0-1-1h-3" />
                  <path stroke-linecap="round" stroke-linejoin="round" d="M9 18.5c.7.5 1.7.75 3 .75s2.3-.25 3-.75" />
                </svg>
              </span>
              <span class="handoff-spinner" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="8" stroke="currentColor" stroke-opacity="0.28" stroke-width="2.2"></circle>
                  <path d="M20 12a8 8 0 0 0-8-8" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"></path>
                </svg>
              </span>
              <span class="handoff-check" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="m7 12.5 3.1 3.1L17.5 8.5" />
                </svg>
              </span>
            </button>
            <span class="handoff-tooltip">Talk to human</span>
          </div>
          <div class="header-action-wrap hidden" id="calendlyButtonWrap">
            <button id="calendlyButton" class="calendly-btn" type="button" aria-label="Book appointment">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </button>
            <span class="handoff-tooltip">Book appointment</span>
          </div>
          <button id="closeTextChat" class="chat-action-btn">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 18 18"
              fill="none"
            >
              <path
                id="close-button-icon"
                d="M9.21387 0.125C11.5101 0.127425 13.7122 1.04041 15.3359 2.66406C16.9596 4.28776 17.8726 6.48988 17.875 8.78613C17.8749 10.4989 17.3676 12.1735 16.416 13.5977C15.4644 15.0219 14.1109 16.1316 12.5283 16.7871C10.9459 17.4425 9.20431 17.6144 7.52441 17.2803C5.84472 16.9461 4.3019 16.1211 3.09082 14.9102C1.87964 13.699 1.05392 12.1555 0.719727 10.4756C0.38557 8.79567 0.557473 7.05415 1.21289 5.47168C1.86833 3.88932 2.97833 2.5366 4.40234 1.58496C5.82644 0.633413 7.50114 0.125111 9.21387 0.125ZM12.1074 1.80176C10.7262 1.22963 9.20557 1.0804 7.73926 1.37207C6.27313 1.6638 4.92618 2.38339 3.86914 3.44043C2.8121 4.49747 2.09251 5.84442 1.80078 7.31055C1.50911 8.77686 1.65834 10.2975 2.23047 11.6787C2.8026 13.0599 3.7716 14.2407 5.01465 15.0713C6.25771 15.9019 7.71983 16.3447 9.21484 16.3447C11.2188 16.3424 13.1396 15.5449 14.5566 14.1279C15.9737 12.7109 16.7711 10.7901 16.7734 8.78613C16.7734 7.29112 16.3306 5.829 15.5 4.58594C14.6694 3.34289 13.4886 2.37389 12.1074 1.80176ZM11.918 5.53125C11.9903 5.53128 12.0621 5.54557 12.1289 5.57324C12.1957 5.60093 12.2565 5.64129 12.3076 5.69238C12.3587 5.74346 12.3991 5.80438 12.4268 5.87109C12.4544 5.93785 12.4687 6.00978 12.4688 6.08203C12.4687 6.15432 12.4544 6.22617 12.4268 6.29297C12.3991 6.35971 12.3587 6.42056 12.3076 6.47168L10.0811 8.69727L9.99316 8.78613L10.0811 8.87402L12.3076 11.0996C12.3587 11.1507 12.3991 11.2116 12.4268 11.2783C12.4544 11.3452 12.4688 11.4169 12.4688 11.4893C12.4687 11.5616 12.4544 11.6334 12.4268 11.7002C12.3991 11.767 12.3587 11.8278 12.3076 11.8789C12.2565 11.93 12.1957 11.9703 12.1289 11.998C12.0621 12.0257 11.9903 12.04 11.918 12.04C11.8456 12.04 11.7739 12.0257 11.707 11.998C11.6403 11.9704 11.5795 11.93 11.5283 11.8789L9.30273 9.65234L9.21484 9.56445L9.12598 9.65234L6.90039 11.8789C6.84927 11.9299 6.78842 11.9704 6.72168 11.998C6.65488 12.0257 6.58303 12.04 6.51074 12.04C6.43849 12.04 6.36656 12.0257 6.2998 11.998C6.23309 11.9704 6.17217 11.93 6.12109 11.8789C6.07 11.8278 6.02964 11.7669 6.00195 11.7002C5.97428 11.6334 5.95999 11.5616 5.95996 11.4893C5.95996 11.4169 5.9743 11.3451 6.00195 11.2783C6.0296 11.2116 6.07006 11.1507 6.12109 11.0996L8.34766 8.87402L8.43555 8.78613L8.34766 8.69727L6.12109 6.47168H6.12012C6.01729 6.36839 5.95996 6.22781 5.95996 6.08203C5.96006 5.93598 6.01782 5.79566 6.12109 5.69238C6.22437 5.5891 6.3647 5.53135 6.51074 5.53125C6.65675 5.53125 6.79706 5.58926 6.90039 5.69238L9.12598 7.91895L9.21484 8.00684L9.30273 7.91895L11.5283 5.69238C11.5794 5.64135 11.6403 5.60089 11.707 5.57324C11.7739 5.54559 11.8456 5.53125 11.918 5.53125Z"
                fill="white"
                stroke-width="0.25"
              />
            </svg>
          </button>
        </div>
      </div>

      <!-- Calendly Container (Overlay) -->
      <div id="calendlyContainer" class="calendly-container">
        <div class="calendly-header">
          <h3 class="calendly-title">Book a Meeting</h3>
          <button id="calendlyCloseButton" class="calendly-close-btn">&times;</button>
        </div>
        <div id="calendlyWidgetWrapper" class="calendly-widget-wrapper"></div>
      </div>

      <!-- Messages Area -->
      <div id="textMessagesArea" class="chat-messages">
        <div class="chat-message"></div>
      </div>

      <!-- Input Area -->
      <div class="chat-input">
       <div id="feedbackBar" class="feedback-bar hidden">
        <p>Was this helpful?</p>
        <button id="feedbackLikeBtn" class="feedback-btn" title="Like">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M14 9V5a3 3 0 00-3-3l-4 9v11h11.28a2 2 0 002-1.7l1.38-9a2 2 0 00-2-2.3H14z" /><path stroke-linecap="round" stroke-linejoin="round" d="M7 22H4a2 2 0 01-2-2v-7a2 2 0 012-2h3" /></svg>
        </button>
        <button id="feedbackDislikeBtn" class="feedback-btn" title="Dislike">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M10 15v4a3 3 0 003 3l4-9V2H5.72a2 2 0 00-2 1.7l-1.38 9a2 2 0 002 2.3H10z" /><path stroke-linecap="round" stroke-linejoin="round" d="M17 2h2.67A2.31 2.31 0 0122 4v7a2.31 2.31 0 01-2.33 2H17" /></svg>
        </button>
      </div>
       <p id="banner-text-paragraph" class="chat-title-paragraph">I am AI powered and learning</p>
        <div class="chat-input-container">
          <input
          id="textMessageInput"
          type="text"
          placeholder="Type your message..."
          class="chat-text-input"
        />
        <div class="chat-send-btn" id="textSendButton">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="50"
            height="50"
            viewBox="0 0 30 30"
            fill="none"
          >
            <rect
              id="send-button-color"
              width="29.0214"
              height="29.0214"
              rx="14.5107"
              fill="#FC0E3F"
            />
            <mask
              id="mask0_983_365"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="9"
              y="8"
              width="14"
              height="13"
            >
              <rect
                x="9.13684"
                y="8.06158"
                width="12.8984"
                height="12.8984"
                fill="url(#pattern0_983_365)"
              />
            </mask>
            <g mask="url(#mask0_983_365)">
              <rect x="9.13684" y="8.06158" width="12.8984" height="12.8984" fill="white" />
            </g>
            <defs>
              <pattern
                id="pattern0_983_365"
                patternContentUnits="objectBoundingBox"
                width="1"
                height="1"
              >
                <use xlink:href="#image0_983_365" transform="scale(0.00195312)" />
              </pattern>
              <image
                id="image0_983_365"
                width="512"
                height="512"
                preserveAspectRatio="none"
                xlink:href="${sendIcon}"
              />
            </defs>
          </svg>
        </div>
        </div>

      </div>
      <div class="chat-footer">
<h3 class="powered-by">
  powered by 
  <a href="https://witzo.ai/" target="_blank" rel="noopener noreferrer" class="powered-by-brand">
    witzo
  </a>
</h3>



      </div>
    </div>

    <!-- Floating Chat Button -->
    <div id="floatingBtn" class="floating">
      <button class="floating-btn hidden" id="floating-btn">
        <svg
          width="32"
          height="26"
          viewBox="0 0 32 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.375 6.3125C0.375 3.27493 2.83743 0.8125 5.875 0.8125H25.8125C28.8501 0.8125 31.3125 3.27493 31.3125 6.3125V15.1743L27.5114 13.7677C27.411 13.7306 27.3319 13.6515 27.2948 13.5511L25.4689 8.6168C25.3507 8.29761 24.8993 8.29761 24.7811 8.6168L22.9552 13.5511C22.9181 13.6515 22.839 13.7306 22.7386 13.7677L17.8043 15.5936C17.4851 15.7118 17.4851 16.1632 17.8043 16.2814L22.7386 18.1073C22.839 18.1444 22.9181 18.2235 22.9552 18.3239L24.3618 22.125H18.9339C18.9202 22.1484 18.9049 22.1714 18.888 22.1939L16.3936 25.5174C16.1186 25.8838 15.5689 25.8838 15.2939 25.5174L12.7994 22.1939C12.7826 22.1714 12.7673 22.1484 12.7536 22.125H5.875C2.83743 22.125 0.375 19.6626 0.375 16.625V6.3125ZM19.1094 8.15215C19.0504 7.99255 18.8246 7.99255 18.7656 8.15215L18.4097 9.11387C18.3911 9.16405 18.3516 9.20363 18.3014 9.2222L17.3397 9.57808C17.1801 9.6371 17.1801 9.8629 17.3397 9.92192L18.3014 10.2778C18.3516 10.2964 18.3911 10.3359 18.4097 10.3861L18.7656 11.3478C18.8246 11.5074 19.0504 11.5074 19.1094 11.3478L19.4653 10.3861C19.4839 10.3359 19.5234 10.2964 19.5736 10.2778L20.5353 9.92192C20.6949 9.8629 20.6949 9.6371 20.5353 9.57808L19.5736 9.2222C19.5234 9.20363 19.4839 9.16405 19.4653 9.11387L19.1094 8.15215Z"
            fill="white"
          />
        </svg>
      </button>
    </div>
  </body>
</html>
`;
